import {
  CLOSE_PANEL,
  FETCH_USER_DATA,
  GET_DOMAIN_DATA,
  GET_MEL_TEMPLATE_LIST,
  GET_MEL_LIST,
  GOTO_URL,
  HIDE_ERROR,
  INDEXED_STEP_IN_PANEL,
  NEXT_STEP_IN_PANEL,
  OPEN_PANEL_WITH_TYPE,
  RESIZE,
  SET_ACTIVITY_INDICATOR,
  SET_DOMAIN_DATA,
  SET_MEL_TEMPLATE_LIST,
  SET_MEL_LIST,
  SET_MODAL_FAILED_VALIDATION,
  SET_TOOLBAR_OPEN_STATE,
  SET_USER_DATA,
  SHAKE_BUILDER,
  THROW_ERROR,
  TOGGLE_ERROR_CONSOLE_OPEN,
  TOGGLE_TOOLBAR_OPEN_STATE,
  UNSET_ACTIVITY_INDICATOR,
  UNSET_MODAL_FAILED_VALIDATION,
} from "../types"

export function getDataForDomain() {
  return { type: GET_DOMAIN_DATA }
}
export function getMelTemplateList() {
  return { type: GET_MEL_TEMPLATE_LIST }
}
export function setMelTemplateList(list) {
  return { type: SET_MEL_TEMPLATE_LIST, list }
}
export function getMelList() {
  return { type: GET_MEL_LIST }
}
export function setMelList(list) {
  return { type: SET_MEL_LIST, list }
}
export function saveDataForDomain(data) {
  return { type: SET_DOMAIN_DATA, data }
}
export function getUserData() {
  return { type: FETCH_USER_DATA }
}
export function setUserData(user) {
  return { type: SET_USER_DATA, user }
}

export function resizeView(size) {
  return { type: RESIZE, size }
}

export function setToolBarOpenState(open) {
  return { type: SET_TOOLBAR_OPEN_STATE, open }
}

export function toggleToolbarOpenState(open) {
  return { type: TOGGLE_TOOLBAR_OPEN_STATE, open }
}

export function gotoURL(url) {
  return { type: GOTO_URL, url }
}

export function openPanelWithType(panel, data) {
  return { type: OPEN_PANEL_WITH_TYPE, panel, data }
}

export function nextStepInPanel() {
  return { type: NEXT_STEP_IN_PANEL }
}

export function indexedStepInPanel(index) {
  return { type: INDEXED_STEP_IN_PANEL, index }
}

export function closePanel() {
  return { type: CLOSE_PANEL }
}

export function throwError(error) {
  return { type: THROW_ERROR, error }
}

export function showAcitivityIndicator(activity) {
  return { type: SET_ACTIVITY_INDICATOR, activity }
}

export function hideAcitivityIndicator(activity) {
  return { type: UNSET_ACTIVITY_INDICATOR, activity }
}

export function hideError() {
  return { type: HIDE_ERROR }
}

export function indicateModalFormValidationFailed() {
  return { type: SET_MODAL_FAILED_VALIDATION }
}

export function unsetFormValidationFailed() {
  return { type: UNSET_MODAL_FAILED_VALIDATION }
}

export function shakeBuilder(validated) {
  return { type: SHAKE_BUILDER, validated }
}

export function toggleErrorConsoleOpen(open) {
  return { type: TOGGLE_ERROR_CONSOLE_OPEN, open }
}
